import React, { useState } from 'react'
import { Okved2 } from '../../../../Org/Handbook/types'
import FormatText from '../../../../Org/Handbook/components/FormatText'

const PurchaseItemsPopupOkved2Search: React.FC<{
    item: any
    theme: string
    onSelected: (value: Okved2) => void
}> = ({ item, onSelected, theme }) => {
    return (
        <div>
            <div className="flex flex-row w-full justify-start text-center">
                {/* Отступ для вложенности */}
                <div
                    className={`flex flex-row w-full gap-1 mx-1 bg-[#f6f6f6] dark:bg-[#2A282B] text-[#181818] dark:text-[#FFFFFF] hover:bg-[#FFFFFF] dark:hover:bg-[#373538] text-[11px] rounded cursor-pointer`}
                    onDoubleClick={() => onSelected(item)}
                >
                    <div className="flex flex-col w-full items-center justify-center">
                        <div className="flex flex-row w-full items-center justify-center">
                            <div className="flex w-8 items-center justify-center text-center text-[#6A6A6A] dark:text-[#8A8A8A]"></div>
                            <div className="flex w-16 text-left justify-left items-center pl-1">
                                {item.code}
                            </div>
                            <div className="flex flex-row flex-1 items-center justify-left text-left px-2 py-2 gap-2">
                                <div className="flex items-center justify-left text-left">
                                    {item.name}
                                </div>
                                <div className="flex items-center justify-left text-left text-[#6A6A6A] dark:text-[#8A8A8A]">
                                    {item.child_counts > 0
                                        ? `(${item.child_counts})`
                                        : ``}
                                </div>
                            </div>
                        </div>
                        {item.add_info ? (
                            <div className="flex flex-row w-full items-center justify-start ">
                                <div className="flex w-8 text-left justify-left items-center pl-1 "></div>
                                <div className="flex w-16 text-left justify-left items-center pl-1 "></div>
                                <div className="flex flex-1 items-center justify-left text-left text-[11px] text-[#6A6A6A] dark:text-[#8A8A8A] pb-2 whitespace-pre-wrap">
                                    <FormatText text={item.add_info} />
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PurchaseItemsPopupOkved2Search
